// separate number
export const separate = (number) => (
    `${number}`.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
)